import axios from "axios";
import * as Constants from "../../../constants/Constants";

export function loginUser(payload) {
  return new Promise(async (resolve, reject) => {
    axios
      .post(Constants.REACT_APP_API_URL + "api/" + Constants.LOGIN, payload, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
